module.exports = __webpack_public_path__ + "img/386df296d510505283209ffc05190a48.png";